module.exports = __webpack_public_path__ + "img/TC_logo_DL.6b4a545c.png";